import { Checkbox, Col, Row, Select, Switch } from 'antd'
// import Select from 'components/Select'
import React from 'react'
import SuccessIcon from '../../../components/icons/SubmitCloseIcon'
import { FilterLabel } from '../../JobRoles/PageHeader/style'
import {
  StyledDynamicText,
  StyledFilterCol,
  StyledFormItem,
} from './StyledComponent'

const getLabel = (key, category) => {
  const isPlacementOrGigs = category === 'PLACEMENT' || category === 'GIGS'
  switch (key) {
    case 'activeJobRoles':
      return 'Active Job Roles'
    case 'jobProfileStatus':
      return 'Job Profile Status'
    case 'studentPlacement':
      return category !== 'PLACEMENT'
        ? 'Student Placed Graph'
        : 'Student Placement Graph'
    case 'ctcBased':
      return isPlacementOrGigs ? 'CTC Based Graph' : 'Stipend Based Graph'
    case 'ctcCategory':
      return isPlacementOrGigs ? 'CTC Category Graph' : 'Stipend Category Graph'
    default:
      return key
  }
}

export default function ExportPDF({
  step,
  data,
  setData,
  state,
  yearData,
  setState,
  studentPlacementRef,
  ctcAnalysisRef,
  ctcCategoryRef,
  jobProfileStatusRef,
}) {
  const handleYearChange = (e, option) => {
    setState(prev => ({
      ...prev,
      compareYear: option?.value ? option?.value : '',
    }))
  }
  const yearSwitchChange = value => {
    setState(prev => ({
      ...prev,
      compareYear: value ? prev?.compareYear : '',
      isCompareYear: value,
    }))
  }

  return (
    <div>
      {step === 1 ? (
        <>
          <StyledDynamicText mb={'10px'} mt={'10px'}>
            Select the graphs you want in your PDF export
          </StyledDynamicText>
          <Row>
            <Col xs={24} md={24} style={{ paddingBottom: '10px' }}>
              <Checkbox
                onChange={() => {
                  const shouldSelectAll = Object.entries(data)
                    .filter(([key]) => {
                      // Exclude disabled checkboxes from "Select All" logic
                      if (
                        key === 'jobProfileStatus' &&
                        jobProfileStatusRef === null
                      )
                        return false
                      if (key === 'ctcBased' && ctcAnalysisRef === null)
                        return false
                      if (key === 'ctcCategory' && ctcCategoryRef === null)
                        return false
                      if (
                        key === 'studentPlacement' &&
                        studentPlacementRef === null
                      )
                        return false
                      return true
                    })
                    .some(([, value]) => !value) // Check if any enabled checkbox is false

                  setData({
                    jobProfileStatus:
                      shouldSelectAll && jobProfileStatusRef !== null,
                    studentPlacement:
                      shouldSelectAll && studentPlacementRef !== null,
                    ctcBased: shouldSelectAll && ctcAnalysisRef !== null,
                    ctcCategory: shouldSelectAll && ctcCategoryRef !== null,
                  })
                }}
                style={{ fontWeight: 600, fontSize: 15 }}
                checked={Object.entries(data)
                  .filter(([key]) => {
                    // Exclude disabled checkboxes from "Select All" checked status
                    if (
                      key === 'jobProfileStatus' &&
                      jobProfileStatusRef === null
                    )
                      return false
                    if (key === 'ctcBased' && ctcAnalysisRef === null)
                      return false
                    if (key === 'ctcCategory' && ctcCategoryRef === null)
                      return false
                    if (
                      key === 'studentPlacement' &&
                      studentPlacementRef === null
                    )
                      return false
                    return true
                  })
                  .every(([, value]) => value)} // Ensure only enabled checkboxes are considered
              >
                Select All
              </Checkbox>
            </Col>
            {Object?.keys(data)?.map((key, index) => {
              return (
                <Col
                  xs={24}
                  md={24}
                  key={index + key}
                  style={{ paddingBottom: '10px' }}
                >
                  <Checkbox
                    label={getLabel(key, state?.selectedCategory)}
                    checked={data[key]}
                    onChange={() => {
                      setData(prevState => ({
                        ...prevState,
                        [key]: !prevState[key],
                      }))
                    }}
                    style={{ fontWeight: 600, fontSize: 15 }}
                    disabled={
                      key === 'jobProfileStatus'
                        ? jobProfileStatusRef === null
                        : key === 'studentPlacement'
                        ? studentPlacementRef === null
                        : key === 'ctcBased'
                        ? ctcAnalysisRef === null
                        : key === 'ctcCategory'
                        ? ctcCategoryRef === null
                        : false
                    }
                  >
                    {getLabel(key, state?.selectedCategory)}
                  </Checkbox>
                </Col>
              )
            })}
          </Row>
        </>
      ) : step == 2 ? (
        <div>
          <div
            style={{
              height: 300,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexDirection: 'column',
            }}
          >
            <SuccessIcon width={100} height={100} />
            <StyledDynamicText align={'center'}>
              Preparing export for <br />
              <b>
                {' '}
                {
                  Object.keys(data).filter(key => data[key] === true)?.length
                }{' '}
                graphs selected{' '}
              </b>
            </StyledDynamicText>
          </div>
          <div>
            <StyledDynamicText mb={'20px'} mt={'20px'}>
              Would you like a comparison between the selected batch{' '}
              <b>&quot;&nbsp;{state?.selectedPassingYear?.year}&quot;&nbsp;</b>
              with another specific batch?
            </StyledDynamicText>
          </div>
          <div>
            <Row>
              <StyledFilterCol md={24} xs={24}>
                <div
                  style={{
                    display: 'flex',
                    width: '100%',
                    alignItems: 'center',
                    gap: 10,
                  }}
                >
                  <FilterLabel whiteSpace="pre">
                    {' '}
                    Selected Passing Year
                  </FilterLabel>
                  <StyledFormItem
                    style={{ width: '180px', marginBottom: '15px' }}
                  >
                    <Select
                      showSearch={true}
                      allowClear={true}
                      OptionData={yearData}
                      placeholder="Select Passing Year"
                      valueParam="year"
                      nameParam="year"
                      colorstyle={true}
                      value={state?.selectedPassingYear?.year}
                      disabled
                      filterOption={(input, option) => {
                        const childrenString = option.children
                          .toString()
                          .toLowerCase()
                        return childrenString?.includes(input.toLowerCase())
                      }}
                      listHeight={180}
                      boxShadow="rgba(123, 97, 255, 0.15) 0px 2px 6px 0px"
                      selectedOptionColor={'#3249D7'}
                    />
                  </StyledFormItem>
                </div>
              </StyledFilterCol>
              <StyledFilterCol md={24} xs={24}>
                <div
                  style={{
                    display: 'flex',
                    width: '100%',
                    alignItems: 'center',
                    gap: 10,
                  }}
                >
                  <FilterLabel whiteSpace="pre">
                    <Switch
                      onChange={yearSwitchChange}
                      checked={state?.isCompareYear}
                    />
                  </FilterLabel>
                  <FilterLabel whiteSpace="pre">Compare with</FilterLabel>
                  <StyledFormItem
                    style={{ width: '180px', marginBottom: '15px' }}
                  >
                    <Select
                      placeholder="Select Passing Year"
                      style={{ flex: 1 }}
                      onChange={handleYearChange}
                      value={state?.compareYear?.year}
                      allowClear
                      showSearch
                      showArrow
                      disabled={!state?.isCompareYear}
                    >
                      {yearData
                        ?.filter(y => y?.year > 0)
                        ?.map(y => (
                          <Select.Option
                            key={y.year}
                            value={y.year}
                            disabled={
                              y.year === state?.selectedPassingYear?.year
                            }
                          >
                            {y.year}
                          </Select.Option>
                        ))}
                    </Select>
                  </StyledFormItem>
                </div>
              </StyledFilterCol>
            </Row>
          </div>
        </div>
      ) : (
        <div
          style={{
            height: '80vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column',
          }}
        >
          <SuccessIcon width={100} height={100} />
          <StyledDynamicText align={'center'}>
            <b>Successful!</b> <br />
            Exporting in Progress
          </StyledDynamicText>
        </div>
      )}
    </div>
  )
}
